import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpEventType
} from "@angular/common/http";
import { Observable, map } from "rxjs";
import { HTTPResponse, isValidResponse } from "@app/shared/models/response.model";

/**
 * Transforms all ussi responses
 */
@Injectable({
  providedIn: "root"
})
export class ResponseInterceptor implements HttpInterceptor {
  private _downloadingFile: boolean = false;

  /**
   * Configure response behaviour
   * Set downloadingFile = true when downloading a file from the server
   * @param downloadingFile
   */
  configure(downloadingFile: boolean) {
    const instance = new ResponseInterceptor();
    instance._downloadingFile = downloadingFile;
    return instance;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse && event.type === HttpEventType.Response) {
          if (!this._downloadingFile) {
            event = event.clone({ body: this.retrieveData(event.body) });
          }
        }
        return event;
      })
    );
  }

  /**
   * Retrieve data portion of the response
   * @param body
   */
  private retrieveData(body: HTTPResponse) {
    return isValidResponse(body) ? body.data[0] : "INVALID USSI RESPONSE";
  }
}
